import React, { useEffect, useRef, useState } from 'react';

interface Props {
  count: number;
  onOpen: () => void;
}

/** Floating "My picks" pill — springs in when the first pick lands. */
const PicksBar: React.FC<Props> = ({ count, onOpen }) => {
  const [pop, setPop] = useState(false);
  const prev = useRef(count);

  useEffect(() => {
    if (count !== prev.current) {
      prev.current = count;
      setPop(false);
      // restart the badge pop animation on every count change
      const raf = requestAnimationFrame(() => setPop(true));
      return () => cancelAnimationFrame(raf);
    }
    return undefined;
  }, [count]);

  return (
    <button
      type="button"
      className={`lc-picksbar ${count > 0 ? 'lc-show' : ''}`.trim()}
      onClick={onOpen}
      aria-label="Open my picks"
    >
      My picks <span className={`lc-badge ${pop ? 'lc-pop' : ''}`.trim()}>{count}</span>
    </button>
  );
};

export default PicksBar;
